import api from '.'

export const taskLanes = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/task-lanes`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/task-lanes`, null, success, fail)
  },
  update (taskId, data, success, fail) {
    api.authenticatedRequest('PUT', `/task-lanes/${taskId}`, data, success, fail)
  },
  delete (taskId, success, fail) {
    api.authenticatedRequest('DELETE', `/task-lanes/${taskId}`, null, success, fail)
  }
}
